import { render } from "./TotalDetail.vue?vue&type=template&id=6e148e0d&scoped=true"
import script from "./TotalDetail.vue?vue&type=script&lang=js"
export * from "./TotalDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e148e0d"]])

export default __exports__